const RibbonIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.4768 12.8901L16.9918 21.4161C17.0087 21.5165 16.9946 21.6197 16.9514 21.7119C16.9081 21.8041 16.8377 21.8808 16.7497 21.9319C16.6616 21.983 16.56 22.006 16.4586 21.9978C16.3571 21.9897 16.2605 21.9507 16.1818 21.8861L12.6018 19.1991C12.4289 19.07 12.219 19.0003 12.0033 19.0003C11.7875 19.0003 11.5776 19.07 11.4048 19.1991L7.81875 21.8851C7.74007 21.9496 7.64361 21.9885 7.54225 21.9967C7.44088 22.0049 7.33942 21.982 7.25141 21.931C7.16341 21.88 7.09303 21.8035 7.04967 21.7115C7.00631 21.6195 6.99204 21.5165 7.00875 21.4161L8.52275 12.8901"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14Z"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RibbonIcon
